import { Sort } from '@angular/material/sort';
import { FilterItemDto } from 'src/core/models/request/filter-item.dto';

export class FilterChange {
  static readonly type = '[QualityDashboardModule] FilterChange';
  constructor(public filters: any) {}
}

export class WidgetsChange {
  static readonly type = '[QualityDashboardModule] WidgetsChange';
  constructor(public widgets: any) {}
}

export class WidgetFilterChange {
  static readonly type = '[QualityDashboardModule] WidgetFilterChange';
  component: string;
  constructor(public filters: FilterItemDto[]) {}
}

export class AgentPerformanceSorterChange {
  static readonly type = '[QualityDashboardModule] AgentPerformanceSorterChange';

  constructor(public sort: Sort) {}
}

export class AgentPerformanceDetailSorterChange {
  static readonly type = '[QualityDashboardModule] AgentPerformanceDetailSorterChange';

  constructor(public sort: Sort) {}
}
